import {GetPredefs, Predefs} from "../lib/predefs"

$(document).ready(function() {
    if (window.location.pathname.startsWith("/user/reset-password/") && window.location.pathname.length === 57) {
        GetPredefs();

        $('#resetPasswordButton').click(function (e) {
            e.preventDefault();
            resetPassword();
        });
    }
});

function resetPassword() {
    let newPasswordInput = $('#passwordInput')

    if($(newPasswordInput).val() !== $('#retypePasswordInput').val()) {
        M.Modal.getInstance(document.getElementById('retypePasswordErrorModal')).open();
        return
    }

    let token = window.location.pathname.split("/")[3];

    let params = {
        token: token,
        new_password: $(newPasswordInput).val()
    }

    $(progressModalHeader).html("Resetting password");
    M.Modal.getInstance(document.getElementById('progressModal')).open();

    $.ajax(Predefs.links.backend_url + '/user/reset_password/reset', {
        method: 'POST',
        data: JSON.stringify(params),
        success: function () {
            M.Modal.getInstance(document.getElementById('progressModal')).close();
            M.Modal.getInstance(document.getElementById('resetPasswordSuccessModal')).open();
        },
        error: function () {
            M.Modal.getInstance(document.getElementById('progressModal')).close();
            M.Modal.getInstance(document.getElementById('resetPasswordErrorModal')).open();
        }
    })
}
